import { BasicLayout, BlankLayout } from '@/layout'

const supplierRouter = {
  path: '/supplier',
  name: 'Supplier',
  component: BasicLayout,
  redirect: '/supplier/index',
  meta: { title: '供应商管理', icon: 'international' },
  children: [
    {
      path: 'index',
      name: 'SupplierList',
      meta: { title: '供应商列表' },
      component: () => import('@/views/supplier/index')
    },
    {
      path: 'detail',
      name: 'SupplierDetail',
      hidden: true,
      meta: { title: '供应商详情', keepAlive: true, activeMenu: '/supplier/index' },
      component: () => import('@/views/supplier/detail')
    },
    {
      path: 'goods',
      name: 'SupplierGoods',
      component: BlankLayout, // Parent router-view
      redirect: '/supplier/goods/index',
      meta: { title: '商品管理', breadcrumb: false },
      children: [
        {
          path: 'index',
          name: 'SupplierGoodList',
          meta: { title: '供应商商品' },
          component: () => import('@/views/supplier/goods/list')
        }
      ]
    },
    {
      path: 'order',
      name: 'SupplierOrder',
      component: BlankLayout, // Parent router-view
      redirect: '/supplier/order/index',
      meta: { title: '订单管理', breadcrumb: false },
      children: [
        {
          path: 'index',
          name: 'SupplierOrderList',
          meta: { title: '供应商订单' },
          component: () => import('@/views/supplier/order/list')
        }
      ]
    }
  ]
}

export default supplierRouter
